const VolunteerStatus = {
  ACTIVE: 'active',
  COMPLETED: 'completed',
  PENDING: 'pending',
  REJECTED: 'rejected',
  ONHOLD: 'onhold',
};

export { VolunteerStatus };
